import { createContext, useContext } from 'react'

import { getScreenShareProfile } from '@/src/lib/screenShareOptions'

/**
 * Общий профиль экрана, зафиксированный при входе в ActiveRoom.
 *
 * Вне провайдера используется 1080p; камерные параметры сюда не входят.
 */
export const ScreenShareProfileContext = createContext(getScreenShareProfile())

/** Возвращает единый профиль захвата и публикации экрана текущего входа. */
export function useScreenShareProfile() {
  return useContext(ScreenShareProfileContext)
}
